import { modifier } from 'ember-modifier';

// scrolls an <EmberTable> to the right after it is inserted
export default modifier(function emberTableScrollRight(element) {
  setTimeout(function () {
    element.scrollLeft = element.scrollWidth;
  });
});
